import { ListItem } from 'components/List'
import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'
import { destinationEnum } from '../../../data/models/funnelOrder/destination'
import { AppState } from '../../../data/state'

interface ExtraLuggageSummaryProps {
  numberOfBags: number
  destination: destinationEnum
}

const ExtraLuggageSummary: React.FC<ExtraLuggageSummaryProps> = props => {
  return (
    <>
      {props.numberOfBags > 0 ? (
        <ListItem>
          <DisplayContent
            addNode
            contentKey="extra-luggage-summary"
            vars={{
              luggageAmount: props.numberOfBags.toString(),
            }}
          >{`Extra luggage (${props.numberOfBags.toString()}x)`}</DisplayContent>
        </ListItem>
      ) : null}
      {props.destination === destinationEnum.outsideEurope ? (
        <ListItem>
          <DisplayContent addNode contentKey="extra-luggage-included-summary">
            Extra Luggage included
          </DisplayContent>
        </ListItem>
      ) : (
        ''
      )}
    </>
  )
}

export default connect((state: AppState) => ({
  numberOfBags: state.funnelOrder.numberOfBags,
  destination: state.funnelOrder.destination,
}))(ExtraLuggageSummary)
